<template>
  <section class="section join-eco-section">
    <div class="container">
      <SectionHead eyebrow="JOIN US">
        加入生态 · <span style="color:#83e6ff">开启共赢</span>
      </SectionHead>
      <p class="section-copy join-copy">
        选择你的身份，三步融入生态共同体。
      </p>
      <div class="join-roles reveal">
        <div
          v-for="r in roles"
          :key="r.slug"
          class="join-role-card"
          @click="$router.push('/register?eco=' + r.slug)"
        >
          <div class="join-role-no">入口 {{ r.no }}</div>
          <div class="join-role-icon" :class="r.c" v-html="r.icon"></div>
          <div class="join-role-name">{{ r.name }}</div>
          <div class="join-role-desc">{{ r.desc }}</div>
          <div class="join-role-link">立即加入 <span class="join-arrow">→</span></div>
        </div>
      </div>
      <div class="join-steps-card reveal">
        <div class="join-steps-title">三步融入生态 · 从加入到共赢</div>
        <div class="join-steps-line">
          <div v-for="s in steps" :key="s.no" class="join-step">
            <div class="join-step-num" :class="s.cls">{{ s.no }}</div>
            <div class="join-step-content">
              <div class="join-step-name">{{ s.name }}</div>
              <div class="join-step-desc">{{ s.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHead from '@/components/display/SectionHead.vue';

const ROLES = [
  {
    slug: 'partner',
    no: '01',
    name: '我是合伙人',
    desc: '适合：有人脉、有项目资源',
    c: 'c01',
    icon:
      '<svg viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>'
  },
  {
    slug: 'service',
    no: '02',
    name: '我是服务商',
    desc: '适合：有交付能力、有团队',
    c: 'c02',
    icon:
      '<svg viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>'
  },
  {
    slug: 'supply',
    no: '03',
    name: '我是供应商',
    desc: '适合：有产品、有资源',
    c: 'c03',
    icon:
      '<svg viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg>'
  },
  {
    slug: 'solution',
    no: '04',
    name: '我是解决方案商',
    desc: '适合：有方案、有技术',
    c: 'c04',
    icon:
      '<svg viewBox="0 0 24 24"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="3" y1="20" x2="21" y2="20"/></svg>'
  }
];

const STEPS = [
  { no: '01', cls: 'n01', name: '注册成为合伙人', desc: '在线填写信息，10 分钟完成注册认证' },
  { no: '02', cls: 'n02', name: '报备项目，使用平台资源', desc: '上报项目线索，调用方案、资质、集采等能力' },
  { no: '03', cls: 'n03', name: '深度协同，打破能力边界', desc: '与生态伙伴共建项目，做大蛋糕共享收益' }
];

export default {
  name: 'HomeJoin',
  components: { SectionHead },
  data() {
    return {
      roles: ROLES,
      steps: STEPS
    };
  }
};
</script>

<style lang="less" scoped>
.join-eco-section {
  background: linear-gradient(180deg, transparent, rgba(12, 32, 63, 0.5), transparent);
  padding-bottom: 80px;
}

.join-copy {
  text-align: center;
  max-width: 700px;
  margin: -30px auto 40px;
}

.join-roles {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  max-width: 1200px;
  margin: 0 auto 50px;
}

.join-role-card {
  padding: 30px 22px 24px;
  border: 1px solid var(--line);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
  border-radius: 20px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  cursor: pointer;

  &:hover {
    border-color: rgba(131, 230, 255, 0.4);
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.22);
    transform: translateY(-4px) !important;

    .join-role-icon {
      transform: translateY(-3px) scale(1.04);
    }
    .join-role-link {
      background: rgba(92, 242, 168, 0.14);
      border-color: rgba(92, 242, 168, 0.55);
    }
    .join-arrow {
      transform: translateX(4px);
    }
  }
}

.join-role-no {
  font-size: 11px;
  font-weight: 700;
  color: #83e6ff;
  letter-spacing: 0.18em;
  margin-bottom: 14px;
  text-transform: uppercase;
  opacity: 0.85;
  position: relative;
  padding-left: 14px;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 8px;
    height: 1px;
    background: #83e6ff;
    transform: translateY(-50%);
    opacity: 0.7;
  }
}

.join-role-icon {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  transition: all 0.3s ease;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    inset: -6px;
    border-radius: 24px;
    background: inherit;
    filter: blur(18px);
    opacity: 0.35;
    z-index: -1;
  }

  ::v-deep svg {
    width: 28px;
    height: 28px;
    stroke: #fff;
    fill: none;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  &.c01 {
    background: linear-gradient(135deg, #3aa0ff 0%, #1f6dd6 100%);
    box-shadow: 0 8px 24px rgba(58, 160, 255, 0.45);
  }
  &.c02 {
    background: linear-gradient(135deg, #9b6bff 0%, #6a3fd6 100%);
    box-shadow: 0 8px 24px rgba(155, 107, 255, 0.45);
  }
  &.c03 {
    background: linear-gradient(135deg, #3ee0c8 0%, #1fa890 100%);
    box-shadow: 0 8px 24px rgba(62, 224, 200, 0.45);
  }
  &.c04 {
    background: linear-gradient(135deg, #ff9a3a 0%, #d66b1f 100%);
    box-shadow: 0 8px 24px rgba(255, 154, 58, 0.45);
  }
}

.join-role-name {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
  letter-spacing: 0.02em;
}

.join-role-desc {
  font-size: 13px;
  color: var(--muted);
  line-height: 1.65;
  margin-bottom: 18px;
  min-height: auto;
  text-align: center;
}

.join-role-link {
  color: #5cf2a8;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 0.04em;
  margin-top: auto;
  padding: 9px 18px;
  border: 1px solid rgba(92, 242, 168, 0.3);
  border-radius: 999px;
  background: rgba(92, 242, 168, 0.06);
  transition: all 0.3s;
}

.join-arrow {
  display: inline-block;
  margin-left: 4px;
  transition: transform 0.2s ease;
}

.join-steps-card {
  max-width: 1080px;
  margin: 0 auto;
  padding: 54px 50px 46px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02));
  border: 1px solid var(--line);
  border-radius: 20px;
  position: relative;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
}

.join-steps-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 54px;
  letter-spacing: 0.04em;
}

.join-steps-line {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  align-items: start;
  position: relative;
  padding: 0 26px;

  &::before {
    content: '';
    position: absolute;
    top: 30px;
    left: 30px;
    right: 30px;
    height: 1px;
    background: linear-gradient(90deg, rgba(66, 217, 255, 0.55) 0%, rgba(62, 224, 200, 0.55) 50%, rgba(66, 217, 255, 0.55) 100%);
    z-index: 0;
  }
}

.join-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
  text-align: center;
}

.join-step-num {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
  border: 2px solid rgba(255, 255, 255, 0.15);
  position: relative;
  z-index: 2;
  margin-bottom: 18px;

  &.n01 {
    background: linear-gradient(135deg, #3aa0ff, #1a6dd9);
  }
  &.n02 {
    background: linear-gradient(135deg, #5cf2a8, #2cb87a);
    color: #0a1520;
  }
  &.n03 {
    background: linear-gradient(135deg, #3aa0ff, #1a6dd9);
  }
}

.join-step-content {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
}

.join-step-name {
  font-size: 17px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.02em;
  line-height: 1.4;
}

.join-step-desc {
  font-size: 13px;
  color: var(--muted);
  line-height: 1.6;
  letter-spacing: 0.02em;
  max-width: 240px;
}

@media (max-width: 960px) {
  .join-roles {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
  .join-steps-line {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 0;

    &::before {
      display: none;
    }
  }
  .join-steps-card {
    padding: 36px 24px 30px;
  }
}

@media (max-width: 560px) {
  .join-roles {
    grid-template-columns: 1fr;
  }
}
</style>
